import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useState } from "react";

const dummyNotifications = [
    {
        id: 1,
        sectionOne: 'The particulars of its organisation, functions and duties',
        sectionTwo: 'The organisation chart, functions and duties of the Department of Agriculture and farmers welfare are available in the Department manual published on the website',
    },
    {
        id: 2,
        sectionOne: 'The powers and duties of its officers and employees',
        sectionTwo: 'The section wise officers in the directorate and all District and block and panchayath level are mentioned in the department manual published on the website.',
    },
    {
        id: 3,
        sectionOne: 'The procedures followed in the decision-making process, including channels of supervision and accountability',
        sectionTwo: 'The hierarchy and channels of supervision for decision making process are mentioned in the Organisation chart published on the website.',
    },
    {
        id: 4,
        sectionOne: 'The norms set by it for the discharge of its functions',
        sectionTwo: 'The rules and norms of the State Government of Kerala are being followed for discharge of the administrative functions.',
    },
    {
        id: 5,
        sectionOne: 'The rules, regulations, instructions, manuals and records held by it or under its control or used by its employees for discharging its functions',
        sectionTwo: 'The rules and regulations of the State Government of Kerala. The Kerala Farmers Debt Relief Commission Act ,2006, The Kerala Conservation of Paddy Land and Wetland Act,2008, The farmers Welfare fund bill 2018, Fertilizer (Control ) Order,1957, The seeds Rules,1968 and Insecticide rules,1971.',
    }
];

// Number of items to display per page
const ITEMS_PER_PAGE = 5;
const SectionFour = () => {

    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the total number of pages
    const totalPages = Math.ceil(dummyNotifications.length / ITEMS_PER_PAGE);

    // Get the notifications for the current page
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentNotifications = dummyNotifications.slice(startIndex, endIndex);

    // Handle page change from the Pagination component
    const handlePageChange = (event, page) => {
        setCurrentPage(page);
    };
    return (
        <div className='p-[10px] w-[100%] text-black bg-[#14608405]'>
            <div className="border-l-2 border-t-2 border-r-2 p-3 font-bold text-center">
                <p>DOCUMENTS AVAILABLE UNDER SECTION 4(1) OF RTI ACT 2005</p>
            </div>
            <div className="border-2 p-3 font-bold text-center">
                <p>The documents available in the Department of Agriculture Development and Farmers Welfare under section 4(1) b of the Right to Information Act 2005 are detailed below.</p>
            </div>
            <div className="overflow-x-auto w-full ">
                <table border='2' className="w-full border-collapse border-2 rounded-lg overflow-hidden shadow-lg">
                    <tbody>
                        {currentNotifications.length > 0 ? (
                            currentNotifications.map((notification, index) => (
                                <tr key={notification.id} className="even:bg-gray-50 hover:bg-gray-100 transition-colors duration-200">
                                    <td className="py-3 px-4 border-b border-r border-gray-200">{index + 1}</td>
                                    <td className="py-3 px-4 border-b border-r border-gray-200">{notification.sectionOne}</td>
                                    <td className="py-3 px-4 border-b border-r border-gray-200">{notification.sectionTwo}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="py-4 text-center text-gray-500 border-b">No notifications available.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="w-full flex justify-center mt-8 mb-10">
                <Stack spacing={2}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                        size="large"
                    />
                </Stack>
            </div>
        </div>
    )
}

export default SectionFour